const base = (window.__CONFIG__ && window.__CONFIG__.API_BASE) || process.env.REACT_APP_BACKEND_URL;

// "same" = API di domain yang sama (mode cPanel Rumahweb dengan PHP)
export const API = `${base === "same" ? "" : base}/api`;

export const LOGO_URL = "./img/logo-pr.jpg";

export const QRIS_URL = "./img/qris.jpg";
export const WHATSAPP_NUMBER = "628983939617";


export const formatRupiah = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);

export const formatNumber = (n) => new Intl.NumberFormat("id-ID").format(n || 0);

export const timeAgo = (iso) => {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "baru saja";
  if (mins < 60) return `${mins} menit lalu`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} jam lalu`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} hari lalu`;
  return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "short" });
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const donateEvent = (campaignId) =>
  window.dispatchEvent(new CustomEvent("donate:program", { detail: { campaignId } }));
